module.exports = __webpack_public_path__ + "media/images/hn-3-fcc97198.jpg";